import { render, staticRenderFns } from "./Kostenanalyse.vue?vue&type=template&id=f93b50a6&"
import script from "./Kostenanalyse.vue?vue&type=script&lang=ts&"
export * from "./Kostenanalyse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports